import React from "react";
import relevanceStairs from "@/assets/relevance-stairs.png";

const RelevanceSection = () => {
  const criteria = [
    "Ya facturas y cierras números, pero no siempre sabes qué significan",
    "Tienes datos, pero te falta estructura y foco",
    "Tomas decisiones importantes con información incompleta",
    "Necesitas una voz financiera sólida en comité de dirección o board",
    "Buscas orden financiero sin sumar capas operativas innecesarias"
  ];

  return (
    <section className="home2-relevance">
      <div className="home2-section-content">
        <div className="home2-relevance-grid">
          <div className="home2-relevance-left">
            <h2 className="home2-relevance-title">
              Para compañías que ya no pueden decidir a ciegas.
            </h2>
            <div className="home2-relevance-image">
              <img src={relevanceStairs} alt="Métricas financieras clave: CAC, margen medio y runway" loading="lazy" />
            </div>
            <p className="home2-relevance-subtitle">
              Elemental Value es para equipos que han superado la fase inicial
              y necesitan criterio financiero real para seguir creciendo con orden.
            </p>
          </div>
          <div className="home2-relevance-right">
            <p className="home2-relevance-label">Trabajamos contigo si:</p>
            <ul className="home2-relevance-list">
              {criteria.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RelevanceSection;
